/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetLandlordShortResponseDto
 */
export interface AssetLandlordShortResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetLandlordShortResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetLandlordShortResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetLandlordShortResponseDto interface.
 */
export function instanceOfAssetLandlordShortResponseDto(value: object): value is AssetLandlordShortResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetLandlordShortResponseDtoFromJSON(json: any): AssetLandlordShortResponseDto {
    return AssetLandlordShortResponseDtoFromJSONTyped(json, false);
}

export function AssetLandlordShortResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetLandlordShortResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetLandlordShortResponseDtoToJSON(json: any): AssetLandlordShortResponseDto {
    return AssetLandlordShortResponseDtoToJSONTyped(json, false);
}

export function AssetLandlordShortResponseDtoToJSONTyped(value?: AssetLandlordShortResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

